<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>公告</el-breadcrumb-item>
      <el-breadcrumb-item>分类管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          :model="filter"
          ref="filterForm"
          label-position="left"
          label-width="70px"
          @submit.native.prevent
        >
          <el-form-item label="名称" prop="name">
            <el-input
              size="small"
              v-model="filter.name"
              @keyup.enter.native="requestSearch"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="mt-10">
          <el-button type="primary" size="small" @click="requestSearch"
            >筛选</el-button
          >
          <el-button size="small" @click="requestSearch('reset')"
            >重置</el-button
          >
        </div>
      </div>
    </div>

    <div class="panel mt-20">
      <div class="header">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          v-permission="Auth.noticeCategoryCreate"
          @click="handleNew"
          >新增分类</el-button
        >
      </div>
      <el-table v-if="!isMobile()" :data="list" stripe style="width: 100%">
        <el-table-column align="left" label="分类名称" prop="whole_name">
        </el-table-column>
        <!-- <el-table-column align="center" label="状态">
          <template slot-scope="scope">
            <status-tag
              :type="scope.row.status == 1 ? 'success' : 'gray'"
              :name="scope.row.status == 1 ? '已启用' : '已禁用'"
            ></status-tag>
          </template>
        </el-table-column> -->
        <el-table-column align="right" label="操作" width="260">
          <template slot-scope="scope">
            <el-button
              class="mr-10"
              type="primary"
              plain
              size="mini"
              @click="handleNew(scope.row, scope.$index)"
              v-if="scope.row.father_id == 0"
              v-permission="Auth.noticeCategoryCreate"
              >添加子分类</el-button
            >
            <!-- <el-popconfirm
              v-permission="Auth.noticeCategoryStatusManage"
              :title="`确认${scope.row.status == 1 ? '禁用' : '启用'}吗？`"
              @confirm="handleSwitchStatus(scope.$index, scope.row.id)"
            >
              <el-button
                slot="reference"
                :type="scope.row.status == 1 ? 'danger' : 'primary'"
                plain
                size="mini"
                >{{ scope.row.status == 1 ? '禁用' : '启用' }}</el-button
              >
            </el-popconfirm> -->
            <el-popconfirm
              v-permission="Auth.noticeCategoryDelete"
              title="确认删除吗？"
              @confirm="handleDelete(scope.$index, scope.row)"
            >
              <el-button
                class="ml-10"
                slot="reference"
                type="danger"
                plain
                size="mini"
                >删除</el-button
              >
            </el-popconfirm>
            <el-button
              class="ml-10"
              type="primary"
              plain
              size="mini"
              @click="handleEdit(scope.$index, scope.row)"
              v-permission="Auth.noticeCategoryUpdate"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <item-former
      :model="model"
      :show.sync="itemFormerVisible"
      @created="createdCallback"
      @updated="updatedCallback"
    ></item-former>
  </div>
</template>

<script>
import {
  noticeCategoryList,
  updateNoticeCategoryStatus,
  deleteNoticeCategory,
} from '@/service/getData'
import { isMobile } from '../../../util'
import ItemFormer from './former'
import { clone } from '@/util'

export default {
  components: {
    ItemFormer,
  },
  data() {
    return {
      model: { name: '' },
      itemFormerVisible: false,
      editIndex: 0,
      isMobile,
      list: [],
      filter: {
        name: '',
      },
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let params = clone(this.filter)

      let res = await noticeCategoryList(params)
      this.list = res.data.list
    },
    requestSearch(reset = '') {
      if (reset == 'reset') {
        this.filter.name = ''
      }
      this.getData()
    },
    createdCallback(data) {
      this.list.splice(this.editIndex, 0, data)
    },
    updatedCallback(data) {
      this.$set(this.list, this.editIndex, data)
    },
    handleNew(cate, index) {
      this.editIndex = 0
      let father_id = 0
      let level = 1
      let father_name = ''
      if (cate) {
        this.editIndex = index + 1
        father_id = cate.id
        father_name = cate.name
        level = cate.level + 1
      }
      this.model = {
        name: '',
        father_id: father_id,
        level: level,
        father_name: father_name,
      }
      this.itemFormerVisible = true
    },

    handleEdit(index, item) {
      this.itemFormerVisible = true
      this.$nextTick(() => {
        this.model = clone(item)
        this.model.father_name = this.model.father.name
        this.editIndex = index
      })
    },

    deleteCallBack(id) {
      let cates = this.list.filter(
        (item) => item.father_id == id || item.id == id
      )
      this.list = this.list.filter(
        (item) => item.father_id != id && item.id != id
      )
      if (cates.length > 0) {
        cates.map((item) => {
          this.deleteCallBack(item.id)
        })
      }
    },
    async handleDelete(index, it) {
      let res = await deleteNoticeCategory(it.id)
      if (res.code == 0) {
        this.deleteCallBack(it.id)
      }
    },

    async handleSwitchStatus(index, id) {
      let res = await updateNoticeCategoryStatus(id)
      if (res.code == 0) {
        this.list[index].status = res.data.status
      }
    },
  },
}
</script>